<template>
    <v-select
        :value="value"
        @input="$emit('input', $event)"
        :items="phases"
        :multiple="multiple"
        :label="
            multiple
                ? $localize('ProjectOverview.phases')
                : $localize('ProjectOverview.phase')
        "
    />
</template>

<script>
export default {
    props: {
        value: [Array, String],
        multiple: {
            type: Boolean,
            default: true,
        },
        allowArchive: Boolean,
    },
    data() {
        return {
            phases: [
                {
                    value: 'request',
                    text: this.$localize('Project.phaseRequests'),
                },
                { value: 'offer', text: this.$localize('Project.phaseOffers') },
                { value: 'order', text: this.$localize('Project.phaseOrders') },
                {
                    value: 'invoice',
                    text: this.$localize('Project.phaseInvoices'),
                },
            ],
        }
    },
    created() {
        if (this.allowArchive) {
            this.phases.push({
                value: 'archive',
                text: this.$localize('Project.phaseArchive'),
            })
        }
    },
}
</script>
